<template> 
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>系统配置</el-breadcrumb-item> 
            </el-breadcrumb>
        </div>
        <div class="container">  
              
            <el-form ref="form" :model="param" size="mini" label-width="0" style="margin-top:-10px;" width="500px;">  
                <el-form-item label="" > 
                    <label class="label">网站名称</label>
                    <span style="margin-left:10px;">{{param.stationName==null?'':param.stationName}}</span>
                    <el-button  type="primary" icon="el-icon-lx-edit" style="float:right;margin-right:30px;"  @click="addBind" >编辑</el-button>  
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">前端域名</label>
                    <span style="margin-left:10px;">{{param.indexUrl}}</span>
                </el-form-item>  
                <el-form-item label="" >
                    <label class="label">后端域名</label>
                    <span style="margin-left:10px;">{{param.stationUrl}}</span>
                </el-form-item>   
                <!--<el-form-item label="" >
                    <label class="label">短信服务商</label>
                    <span style="margin-left:10px;">{{param.smsType==1?'腾讯云短信':param.smsType==2?'阿里云短信':param.smsType}}</span>
                </el-form-item>    
                <el-form-item v-if="param.smsType=='1'" label="" >
                    <label class="label">短信AppId</label>
                    <span style="margin-left:10px;">{{param.smsAppId==null?'无':param.smsAppId}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='1'" label="" >
                    <label class="label">短信AppKey</label>
                    <span style="margin-left:10px;">{{param.smsSecretKey==null?'无':param.smsSecretKey}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='1'" label="" >
                    <label class="label">短信签名</label>
                    <span style="margin-left:10px;">{{param.smsSignId==null?'无':param.smsSignId}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='1'" label="" >
                    <label class="label">短信模板</label>
                    <span style="margin-left:10px;">{{param.smsTemplateId==null?'无':param.smsTemplateId}}</span>
                </el-form-item>   
                <el-form-item v-if="param.smsType=='2'" label="" >
                    <label class="label">短信appid</label>
                    <span style="margin-left:10px;">{{param.smsKeyId==null?'无':param.smsKeyId}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='2'" label="" >
                    <label class="label">短信secret</label>
                    <span style="margin-left:10px;">{{param.smsKeyId==null?'无':param.smsKeySecret}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='2'" label="" >
                    <label class="label">短信签名</label>
                    <span style="margin-left:10px;">{{param.smsSignName==null?'无':param.smsSignName}}</span>
                </el-form-item> 
                <el-form-item v-if="param.smsType=='2'" label="" >
                    <label class="label">短信模板</label>
                    <span style="margin-left:10px;">{{param.smsTemplateCode==null?'无':param.smsTemplateCode}}</span>
                </el-form-item>  -->
                <el-form-item label="" >
                    <label class="label">对象存储ak</label>
                    <span style="margin-left:10px;">{{param.qiniuAk}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">对象存储sk</label>
                    <span style="margin-left:10px;">{{param.qiniuSk}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">空间名称</label>
                    <span style="margin-left:10px;">{{param.qiniuBucketname}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">空间位置</label>
                    <span style="margin-left:10px;">{{param.qiniuSpacetype==1?'华东':param.qiniuSpacetype==2?'华北':param.qiniuSpacetype==3?'华南':param.qiniuSpacetype}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">空间域名</label>
                    <span style="margin-left:10px;">{{param.qiniuDomain}}</span>
                </el-form-item>  
                <el-form-item label="" >
                    <label class="label">系统到期时间</label>
                    <span style="margin-left:10px;">{{param.endTime}}</span>
                </el-form-item> 
                <el-form-item label="" > 
                    <label class="label">网站logo</label>
                    <div style="margin-left:120px;margin-top:-30px"> 
                        <span v-if="param.stationLogo==null" style="margin-left:10px;">待上传</span>
                        <img v-else  :src="param.stationLogo" style="width:100px;height:100px;margin-left:10px;"/>
                    </div> 
                </el-form-item> 
                <el-form-item label="" > 
                    <label class="label" style="float:left">登录背景</label>
                    <div style="margin-right:80px;float:left;text-align:center;"> 
                    
                        <img  :src="param.bgPhone" style="width:100px;height:200px;margin-left:10px;"/>
                        <p style="position:absolute;top:5px;margin-left:35px;color:#ddd;">移动端</p>
                    </div> 
                    <div class="bgImg" style="float:left;text-align:center;"> 
                        <img :src="param.bgPc" style="width:400px;height:200px;margin-left:10px;"/>
                        <p style="position:absolute;top:5px;margin-left:135px;color:#ddd;">PC端</p>
                    </div> 
                </el-form-item>  
               
            </el-form>
        </div>
         
        <el-dialog :close-on-click-modal="false" title="系统配置" :modal-append-to-body='false' :visible.sync="show" width="550px" @close="close"   top="30px">
            <div style="height:500px;width:480px;padding:10px;border:1px solid #ddd">
                <div  style="height:500px;overflow-y:scroll;"> 
                    <el-form ref="form" :model="form" label-width="0">  
                        <el-form-item label=""   >
                            <label class="label">网站名称</label>
                            <el-input  v-model.trim="form.stationName" style="width:300px" placeholder="不超过10个字"></el-input>  
                        </el-form-item>  
                        <el-form-item label=""   >
                            <label class="label">前端域名</label>
                            <el-input  v-model.trim="form.indexUrl" style="width:300px" placeholder="不含http或https"></el-input>  
                        </el-form-item>  
                        <el-form-item label=""   >
                            <label class="label">后端域名</label>
                            <el-input  v-model.trim="form.stationUrl" style="width:300px" placeholder="不含http或https"></el-input>  
                        </el-form-item>   
                        <!--<el-form-item label="" >
                            <label class="label">短信服务商</label>
                            <el-radio-group v-model.trim="form.smsType" >
                                <el-radio-button label="1">腾讯云短信</el-radio-button>
                                <el-radio-button label="2">阿里云短信</el-radio-button> 
                            </el-radio-group>  
                        </el-form-item>    
                        <el-form-item v-if="form.smsType==1" label="" >
                            <label class="label">短信AppId</label>
                            <el-input style="width:300px" v-model.trim="form.smsAppId"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==1" label="" >
                            <label class="label">短信AppKey</label>
                            <el-input style="width:300px" v-model.trim="form.smsSecretKey"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==1" label="" >
                            <label class="label">短信签名</label>
                            <el-input style="width:300px" v-model.trim="form.smsSignId"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==1" label="" >
                            <label class="label">短信模板</label>
                            <el-input style="width:300px" v-model.trim="form.smsTemplateId"   placeholder=" " ></el-input>
                        </el-form-item>  
                        <el-form-item v-if="form.smsType==2" label="" >
                            <label class="label">短信appid</label>
                        <el-input style="width:300px" v-model.trim="form.smsKeyId"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==2" label="" >
                            <label class="label">短信secret</label>
                        <el-input style="width:300px" v-model.trim="form.smsKeySecret"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==2" label="" >
                            <label class="label">短信签名</label>
                        <el-input style="width:300px" v-model.trim="form.smsSignName"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.smsType==2" label="" >
                            <label class="label">短信模板</label>
                        <el-input style="width:300px" v-model.trim="form.smsTemplateCode"   placeholder=" " ></el-input>
                        </el-form-item> -->
                        <el-form-item label="" >
                            <label class="label">储存空间</label>
                            <el-radio-group v-model.trim="form.spaceType" >
                                <el-radio-button label="1">七牛云</el-radio-button> 
                            </el-radio-group>  
                        </el-form-item>    
                        <el-form-item label="" >
                            <label class="label">对象存储ak</label>
                        <el-input style="width:300px" v-model.trim="form.qiniuAk"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item label="" >
                            <label class="label">对象存储sk</label>
                        <el-input style="width:300px" v-model.trim="form.qiniuSk"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item label="" >
                            <label class="label">储存空间名称</label>
                        <el-input style="width:300px" v-model.trim="form.qiniuBucketname"   placeholder=" " ></el-input>
                        </el-form-item>
                        <el-form-item label="" >
                            <label class="label">储存空间位置</label>
                            <el-radio-group v-model.trim="form.qiniuSpacetype" >
                                <el-radio-button label="1">华东</el-radio-button>
                                <el-radio-button label="2">华北</el-radio-button> 
                                <el-radio-button label="3">华南</el-radio-button> 
                            </el-radio-group>   
                        </el-form-item>
                        <el-form-item label="" >
                            <label class="label">空间域名</label>
                            <el-input style="width:300px" v-model.trim="form.qiniuDomain"   placeholder=" " ></el-input>
                        </el-form-item>   
                        <el-form-item > 
                            <label class="label">网站logo</label>
                            <div> 
                                <img :src="form.stationLogo" style="width: 100px;height: 100px;border:1px solid #ddd">
                                <div style="position: relative;width: 100px;height: 100px; margin-top:-110px;margin-left:-100px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                                    <input type="file" name="image" accept="image/*" @change="chageImage1" style="position: absolute; width: 100px; height: 100px; cursor: pointer;left:100px" />
                                </div>
                            </div> <span style="font-size:12px;display:inline-block;float:left;margin-left:120px;margin-top:-68px;color:#999;">LOGO修改后，重新登录才显示</span>
                        </el-form-item > 
                        <el-form-item label=""   > 
                            <label class="label"  style="float:left;">移动端背景</label> 
                                <div style="width:200px;"> 
                                    <img :src="form.bgPhone" style="width: 100px;height: 200px;border:1px solid #ddd">
                                    <div style="width: 100px;height: 200px;line-height: 200px;margin-top:-210px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                                        <input type="file" name="image" accept="image/*" @change="chageImage2" style="position: absolute; width: 100px; height: 200px; cursor: pointer;" />
                                    </div>
                                </div> 
                        </el-form-item >  
                        <el-form-item  style="margin-top:10px">  
                            <label class="label">PC端背景</label> 
                            <div style="width:200px;"> 
                                <img :src="form.bgPc" style="width: 260px;height: 130px;border:1px solid #ddd">
                                <div style="width: 260px;height: 130px;line-height: 200px;margin-top:-145px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                                    <input type="file" name="image" accept="image/*" @change="chageImage3" style="position: absolute; width: 260px; height: 130px; cursor: pointer;" />
                                </div>
                            </div> 
                        </el-form-item >  
                    </el-form> 
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="saveChange">确 定</el-button>
            </span>
        </el-dialog>    


    </div>
</template>

<script> 
import {fetchData,updateData} from '../../api/webSiteConfig';   
export default {

    data() {
        return {    
            show:false,
            loading:false,
            password:'type',
            smsItem:true,
            form: {    
            },   
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            loginPass:'******',
            avatar:require('/public/base-img.png') ,
            param:{avatar:'',},
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {    
         //刷新
        refresh(){
            history.go(0); 
        }, 
        addBind(){
            let data = this.param;
            this.form = data; 
            this.show = true;
        },
        close(){
            this.show = false;
        },
        //主图修改
        chageImage1(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                 this.form.stationLogo = event.target.result;   
                this.$set(this.form, 'stationLogo',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        }, 
        //主图修改
        chageImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }  
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                 this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form.bgPhone = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        //主图修改
        chageImage3(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                 this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form.bgPc = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        //发送验证码
        sendCode(){  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 119;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            this.sendSms.sendFag = "1";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = this.form.phone;   
            this.sendSms.code = "-1";
            sendNextCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData(this.query);
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
        saveChange(){
            // 编辑 
            
            /*if( !this.form.smsType){
                this.$message.error("请选择短信服务商");
                return;
            }
            if( !this.form.smsKeyId){
                this.$message.error("请填写短信appid");
                return;
            }
            if( !this.form.smsKeySecret){
                this.$message.error("请填写短信secret");
                return;
            }
            if( !this.form.smsSignName){
                this.$message.error("请填写短信签名");
                return;
            }
            if( !this.form.smsTemplateCode){
                this.$message.error("请填写短信模板");
                return;
            } */
            if( !this.form.qiniuBucketname){
                this.$message.error("请填写空间名称");
                return;
            }
            if( !this.form.qiniuAk){
                this.$message.error("请填写ak");
                return;
            }
            if( !this.form.qiniuSk){
                this.$message.error("请填写sK");
                return;
            }
            if( !this.form.qiniuSpacetype){
                this.$message.error("请选择空间位置");
                return;
            }
            if( !this.form.qiniuDomain){
                this.$message.error("请填写空间域名");
                return;
            } 
            if( !this.form.qiniuDomain.includes('http')){
                this.$message.error("空间域名必须包含http://或https://");
                return;
            } 
            this.show = false; 
            updateData(this.form).then(res => {  
                if(res.code=='200'){ 
                    localStorage.setItem(window.location.hostname+'_stationLogo', this.form.stationLogo);   
                    localStorage.setItem(window.location.hostname+'_stationName', this.form.stationName); 
                    history.go(0);  
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.$message.error(res.message);
                }  
            });
        },

        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.param).then(res => {  
                if(res.code=='200'){ 
                    this.param = res.data; 
                }else{
                    this.$message("暂无数据");
                } 
                
            });
        },  
         
        //主图修改
        chageImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.param.avatar = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        
    }
};
</script>
<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
</style>
<style>
  
  .el-dialog__body{
      padding:10px 20px;
  }
.handle-del{ 
    margin-left:15px;
}
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
     margin-bottom:10px;
 }
</style>
